import React__default from 'react';
import { cssShorthandPropsFilter } from '../primitives/Spacer/index.js';
import { StyledFlex } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const FlexRoot = React__default.forwardRef(({
  flexDirection,
  align,
  justify,
  wrap,
  basis,
  grow,
  shrink,
  className,
  as,
  children,
  'data-testid': dataTestId,
  ...rest
}, ref) => {
  const styleProps = {
    display: 'flex',
    flexDirection: flexDirection,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    flexBasis: basis,
    flexGrow: grow,
    flexShrink: shrink,
    ...cssShorthandPropsFilter(rest, true)
  };
  const otherProps = rest;
  return jsx(StyledFlex, {
    ref: ref,
    className: className,
    css: styleProps,
    children: children,
    "data-testid": dataTestId,
    ...otherProps,
    as: as
  });
});
const FlexColumn = props => {
  return jsx(Flex, {
    flexDirection: "column",
    ...props
  });
};
const Flex = Object.assign(FlexRoot, {
  Column: FlexColumn
});

export { Flex };
